import { Component } from '@angular/core';

@Component({
  selector: 'app-call-roleplay-results',
  standalone: true,
  templateUrl: './call-roleplay-results.component.html',
  styleUrls: ['./call-roleplay-results.component.scss'],
})
export class CallRoleplayResultsComponent {}
